import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=fa05a52a"
import script from "./ColumnHeader.vue?vue&type=script&lang=ts"
export * from "./ColumnHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa05a52a')) {
      api.createRecord('fa05a52a', component.options)
    } else {
      api.reload('fa05a52a', component.options)
    }
    module.hot.accept("./ColumnHeader.vue?vue&type=template&id=fa05a52a", function () {
      api.rerender('fa05a52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generic/ColumnHeader.vue"
export default component.exports